module.exports = __webpack_public_path__ + "img/dashboard.09f2785e.svg";